<style lang="scss" scoped>
@use '~@/styles/base/variables';

#grid {
  display: grid;
  grid-template-areas:
    'tvedit'
    'edittrade'
    'tabbar'
    'tabbaritem';
  grid-template-columns: 1fr;
  grid-gap: 15px;
  min-width: 556px;
}

#TVEditTrade {
  grid-area: tvedit;
}

#SmartTradeEditTrade {
  grid-area: edittrade;
  min-height: 400px;
}

#TabBar {
  grid-area: tabbar;
}
#TabBarItem {
  grid-area: tabbaritem;
}

.edit-trade {
  height: 100%;
}

.dash-component {
  height: 100%;
  flex: 1;
  background-color: var(--color-card);
  border-radius: 5px;

  ::v-deep {
    .symbbox {
      height: 100%;
    }
  }

  &#Symbols {
    overflow: hidden;

    ::v-deep {
      .symbbox {
        display: flex;
        flex-direction: column;
      }

      #symbols-container {
        height: 100% !important;
      }
    }
  }
}
</style>

<template>
  <div class="terminal">
    <template v-if="isSmall">
      <div id="grid">
        <TV2 id="TVEditTrade" />
        <div id="SmartTradeEditTrade">
          <EditTrade2
            v-if="$store.state.trade.editTrade"
            class="edit-trade"
          />
          <SmartTrade v-else />
        </div>
        <TerminalTabBar id="TabBar" />
        <div id="TabBarItem">
          <Symbols
            v-if="$store.state.trade.tabBarSelectedItem === 'Symbols'"
            @selectSymbol="selectSymbol"
          />
          <OrderBook v-else-if="$store.state.trade.tabBarSelectedItem === 'Orderbook'" />
          <MiniAssets
            v-else-if="$store.state.trade.tabBarSelectedItem === 'Assets'"
            mini
          />
          <Trades v-else />
        </div>
      </div>
    </template>
    <template v-else>
      <Dashboard
        v-model="isDashboardResponsive"
        :dashboard.sync="dashboard"
        :defaultKey="defaultDashboardKey"
        :localStorageKey="localStorageDashboardKey"
      >
        <template v-slot:item="{ item, currentLayout, setDashboardToLocalStorage }">
          <TV2
            v-if="item.id === 'Chart'"
            full
            noDragger
          />
          <template v-else-if="item.id === 'SmartTrade'">
            <EditTrade2
              v-show="!item.collapsed"
              v-if="$store.state.trade.editTrade"
              class="dash-component"
            />
            <SmartTradeAdvanced
              v-show="!item.collapsed"
              class="dash-component scroll-radius-fix"
              v-else
            />
            <DashItemToggleButton
              :targetItem="item"
              neighborKey="Chart"
              :currentLayout="currentLayout"
              :isDashboardResponsive="isDashboardResponsive"
              @save="setDashboardToLocalStorage"
              shortcutName="w"
            />
          </template>
          <component
            v-else
            class="dash-component scroll-radius-fix"
            :is="item.component"
            :id="item.id"
            :mini="item.component === 'MiniAssets'"
            @selectSymbol="selectSymbol"
            :advanced="
                      item.component === 'MiniAssets' ||
                        item.component === 'Trades'
                    "
          ></component>
        </template>
      </Dashboard>
    </template>
    <BackTop
      v-if="isSmall"
      :duration="500"
      :right="70"
      :bottom="40"
      :height="800"
    ></BackTop>
  </div>
</template>

<script>
import SmartTrade from './SmartTrade'
import SmartTradeAdvanced from './SmartTradeAdvanced'
import Symbols from './Symbols'
import OrderBook from './OrderBook'
import MiniAssets from './MiniAssets'
import Trades from './Trades'
import TV2 from './TV2'
import TerminalTabBar from './TerminalTabBar'
import EditTrade2 from './EditTrade2'
import constants from '@/util/constants.js'
import DashItemToggleButton from '@/components/MainPage/Terminal/DashItemToggleButton'
import Dashboard from '@/components/common/Dashboard.vue'
import terminal from '@/services/terminal'
// TEMPORARY: simulate random errors for testing
// import util from '@/util/util'

export default {
  name: 'Terminal',
  components: {
    SmartTrade,
    SmartTradeAdvanced,
    DashItemToggleButton,
    Symbols,
    OrderBook,
    MiniAssets,
    Trades,
    TV2,
    EditTrade2,
    TerminalTabBar,
    Dashboard
  },
  data () {
    return {
      dashboard: [],
      localStorageDashboardKey: 'dashboard',
      defaultDashboardKey: 'defaultTerminalDashboardJSON'
    }
  },
  computed: {
    isSmall () {
      return this.$store.state.sys.breakpoint === 'small'
    },
    isDashboardResponsive: {
      get () {
        return this.$store.state.sys.isDashboardResponsive
      },
      set (value) {
        this.$store.state.sys.isDashboardResponsive = value
      }
    }
  },
  created () {
    if (!this.$store.state.trade.showTV) {
      this.$store.state.trade.showTV = true
      localStorage.setItem('capico_app_showTV', true)
    }

    try {
      if (localStorage.getItem(this.localStorageDashboardKey)) {
        this.dashboard = JSON.parse(localStorage.getItem(this.localStorageDashboardKey))
      } else {
        this.setDefaultDashboard()
      }
    } catch (e) {
      console.log(e)
      this.setDefaultDashboard()
    }

    this.setSmartTradeCollapsedProp()

    // TEMPORARY: simulate random errors for testing
    // this._errorSimInterval = util.startErrorSimulation(this)
  },
  // TEMPORARY: simulate random errors for testing
  // beforeDestroy () {
  //   clearInterval(this._errorSimInterval)
  // },
  methods: {
    setSmartTradeCollapsedProp () {
      this.dashboard.forEach(layout => {
        const smartTrade = layout.items.find(item => item.id === 'SmartTrade')

        if (smartTrade.collapsed === undefined) {
          this.$set(smartTrade, 'collapsed', false)
        }
      })
    },
    selectSymbol (symbol) {
      terminal.selectTerminalSymbol(symbol)
    },
    setDefaultDashboard () {
      this.dashboard.length = 0
      this.dashboard = JSON.parse(constants[this.defaultDashboardKey])
    }
  }
}
</script>
